const CANONICAL_TIERS = ["free", "trial", "solo", "team", "growth", "enterprise", "full_enterprise"];

export function normalizePlanTier(planTier) {
  if (!planTier || typeof planTier !== "string") return "free";

  const tier = planTier.toLowerCase().trim();

  // v5: "free" and "trial" are DISTINCT tiers
  // "free" = post-trial limited, "trial" = 30-day full access
  if (tier === "free") return "free";
  if (tier === "trial") return "trial";

  if (
    tier === "solo" ||
    tier.startsWith("solo_") ||
    tier === "starter" ||
    tier === "basic"
  ) {
    return "solo";
  }

  if (
    tier === "pro" ||
    tier === "professional" ||
    tier === "team" ||
    tier.startsWith("team_")
  ) {
    return "team";
  }

  if (
    tier === "business" ||
    tier === "growth" ||
    tier.startsWith("growth_")
  ) {
    return "growth";
  }

  if (
    tier === "full_enterprise" ||
    tier.startsWith("full_enterprise_")
  ) {
    return "full_enterprise";
  }

  if (tier === "enterprise" || tier.startsWith("enterprise_")) {
    return "enterprise";
  }

  return "free";
}

export function isCanonicalTier(tier) {
  return CANONICAL_TIERS.includes(tier);
}

export const TIER_DISPLAY_NAMES = {
  free: 'Free',
  trial: 'Free (Full Access)',
  solo: 'Starter',
  team: 'Pro',
  growth: 'Business',
  enterprise: 'Enterprise',
  full_enterprise: 'Full Enterprise Automation',
};
